// extracted by mini-css-extract-plugin
export var altaccent = "AltFooter-module--altaccent--4e60d";
export var certification = "AltFooter-module--certification--3040f";
export var certificationList = "AltFooter-module--certification-list--13900";
export var copyright = "AltFooter-module--copyright--09f9c";
export var footer = "AltFooter-module--footer--315f1";
export var groupLogo = "AltFooter-module--group-logo--2635f";
export var isoLogo = "AltFooter-module--iso-logo--96e09";
export var layout = "AltFooter-module--layout--180b5";
export var layoutColumns = "AltFooter-module--layout-columns--83f88";
export var light = "AltFooter-module--light--88786";
export var link = "AltFooter-module--link--1426b";
export var list = "AltFooter-module--list--4768f";
export var logo = "AltFooter-module--logo--f9a30";
export var platform = "AltFooter-module--platform--5e1be";
export var small = "AltFooter-module--small--fe5aa";
export var socialIcon = "AltFooter-module--social-icon--b7238";
export var subNavigation = "AltFooter-module--sub-navigation--81a43";